export const PURCHASE_CREDITS_SCREEN = {
  SOMETHING_WENT_WRONG: 'Something went wrong.',
  PURCHASE_CREDITS: 'Purchase Credits',
  CONFIRMED_PURCHASE: 'Confirmed purchase',
  CREDIT_UPDATE_MESSAGE: 'Your credit will be updated within 24h',
  GO_BACK_TO_DASHBOARD: 'Go back to Dashboard',
  MASTERCARD: 'Mastercard',
  VISA: 'Visa',
  CURRENT_CREDITS: 'Current Credits',
  CREDIT_AMOUNT_TO_BE_PURCHASED: 'Credit Amount to be Purchased',
  CREDIT_VALUE: '1 credit = £0.034 + 20% VAT',
  CARD_NUMBER: 'Card Number',
  CVV: 'CVV',
  EXPIRATION_DATE: 'Expiration Date',
  CONFIRM_AND_PAY: 'Confirm & Pay',
  CANCEL: 'Cancel',
  CREDIT_COST: 'Credits cost: ',
  COMPANY_NAME: 'Company name (for invoicing)',
};
export const singleCreditCost = 0.034;
export const vatRate = 1.2;
